<div class="inline">
  <div *ngIf="editing">
    <input type="number" min="1" max="100" [required]="required" [name]="value" [(ngModel)]="value" />

    <div class="actions">
      <button (click)="onSave()" class="btn-save">Salvar</button>
      <button (click)="onCancel()" class="btn-cancel">Cancelar</button>
    </div>
  </div>
  <div *ngIf="!editing">
    <a href="#" (click)="beginEdit(value)" (focus)="beginEdit(value)" tabindex="0">{{ value }}</a>
  </div>
</div>
